<template>
<div>
<div class="panal mt-20">
<div class="panal-header">Peronal Data </div>


<form name="form" @submit.prevent="handleRegister">
 <h6 class="blocked">Arabic Name</h6>
  <div class="row">
 
    <div class="col-12 col-md-3 mb-1">
      
      <input type="text" v-validate="'required'" class="form-control su-border" v-b-tooltip.hover title="First name" placeholder="First name" v-model="ApplicantData.FirstNameAR">
    </div>
    <div class="col-12 col-md-3 mb-1">
      <input type="text" v-validate="'required'" class="form-control su-border" v-b-tooltip.hover title="Second name" placeholder="Second name" v-model="ApplicantData.SecondNameAR">
    </div>
    <div class="col-12 col-md-2 mb-1">
      <input type="text" v-validate="'required'" class="form-control su-border" v-b-tooltip.hover title="Third name" placeholder="Third name" v-model="ApplicantData.ThirdNameAR">
    </div>
     <div class="col-12 col-md-2 mb-1">
      <input type="text" class="form-control su-border" v-b-tooltip.hover title="Family name" placeholder="Family name optional" v-model="ApplicantData.FamilyNameAR">
    </div>
    <div class="col-12 col-md-2 mb-1">
      <input type="text" v-validate="'required'" class="form-control su-border"  v-b-tooltip.hover title="Last name" placeholder="Last name" v-model="ApplicantData.LastNameAR">
    </div>
  </div> 
  <h6 class=" mt-20">English Name</h6>
  <div class="row">
 
    <div class="col-12 col-md-3 mb-1">
      <input type="text" v-validate="'required'" class="form-control su-border"  placeholder="First name" v-model="ApplicantData.FirstNameEN" disabled >
    </div>
    <div class="col-12 col-md-3 mb-1">
      <input type="text" v-validate="'required'" class="form-control su-border" v-b-tooltip.hover title="Second name" placeholder="Second name" v-model="ApplicantData.SecondNameEN">
    </div>
    <div class="col-12 col-md-2 mb-1">
      <input type="text" v-validate="'required'" class="form-control su-border" v-b-tooltip.hover title="Third name" placeholder="Third name" v-model="ApplicantData.ThirdNameEN">
      
    </div>
    <div class="col-12 col-md-2 mb-1">
      <input type="text" class="form-control su-border" v-b-tooltip.hover title="Family name" placeholder="Family name optional" v-model="ApplicantData.FamilyNameEN">
      
    </div>
    <div class="col-12 col-md-2 mb-1">
      <input type="text" v-validate="'required'" class="form-control su-border" placeholder="Last name" v-model="ApplicantData.LastNameEN" disabled>
    </div>
  </div>

   
  <div class="row">

        <div class="col-12 col-md-6 mb-1">
        <h6 class="mt-20">Religion</h6>
        <select  class="form-control su-border" v-model="ApplicantData.ReligionID">
          <b-form-select-option :value="null">Please select Religion</b-form-select-option>
          <option v-validate="'required|excluded:0'" v-for="region in ReligionList" :value="region.serial" v-bind:key="region.serial">{{region.ReligionNameEN}}</option>
        </select>
        </div>
        <div class="col-12 col-md-6 mb-1">
        <h6 class=" mt-20">Nationality</h6>
        <select disabled class="form-control su-border" v-model="ApplicantData.NationalityId" >
          <b-form-select-option :value="null">Please select Nationality</b-form-select-option>
          <option v-for="national in nationalityList" :value="national.Serial" v-bind:key="national.Serial">{{national.NationalityNameEN}}</option>

        </select>
        </div>
    </div>


<div class="row">

        <div class="col-12 col-md-6 mb-1">
        <h6 class="mt-20">National ID</h6>
        <input disabled type="text" class="form-control su-border" placeholder="123-123-456" v-model="ApplicantData.NationID">
        </div>
        <div class="col-12 col-md-6 mb-1">
        <h6 class=" mt-20">Date of Birth</h6>
         <input :disabled="true" type="text" class="form-control su-border" placeholder="Birth" v-model="ApplicantData.BirthDate">
        </div>
    </div>

<div class="row mt-20 text-center" >
 <div class="col">
 <button class="btn btn-primary text-center" type="submit"  :disabled="loading">
   <span v-show="loading" class="spinner-border spinner-border-sm"></span>
   Save </button>
 </div>

  </div>

</form>
   <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>

</div>
</div>

</template>

<script>
   import {
        ApplicantData
    } from '../../models/Applicant';
    import ApplicantService from "../../services/Applicant/Applicant.service";
    import ApplicantDataService from "../../services/Applicant/ApplicantData.services";

export default {
        name: 'Personal' ,
        data(){
          return{
            ApplicantData : new ApplicantData(),
            ReligionList:[],
            nationalityList:[],
            message: '',
            submitted:false,
            loading: false,
            successful: false,

          }
        },

    
 computed: {
    currentUser() {
           return this.$store.state.auth.user;
      },
  reviewApplication() {
        return this.$store.state.auth.renderReview
      }
  },
  mounted(){
   // this.ApplicantData = this.$store.state.auth.user
     ApplicantService.GetReligionList().then(Response =>{
          this.ReligionList=Response.data
        }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });

        ApplicantService.GetNationalityList().then(Response =>{
          this.nationalityList=Response.data
        }, error => {
             
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            }
        
        );
           
      ApplicantService.GetRegesterdData(this.currentUser.UserIDSerial).then(Response =>{
                  
                  this.ApplicantData = Response.data
                 
                })
  },
  methods:{
    isArabicChars(text) {
      var arregex = /^[\u0621-\u064A\s\p{N}]+$/;
      return arregex.test(text);
    },
    isEnglishChar(name){
      var reg = /^[a-zA-Z]+$/;

      return reg.test(name);
    },
  handleRegister() {
     this.message = '';
        this.submitted = true;
       if(!this.isArabicChars(this.ApplicantData.FirstNameAR)){
         alert('You are not using arabic letters For First name Arabic')
         return
       }
      else if(!this.isArabicChars(this.ApplicantData.SecondNameAR)){
         alert('You are not using arabic letters For Second name Arabic')
         return
       }
      else if(!this.isArabicChars(this.ApplicantData.ThirdNameAR)){
         alert('You are not using arabic letters For Third name Arabic')
         return
       }
      else if(!this.isArabicChars(this.ApplicantData.FamilyNameAR) && this.ApplicantData.FamilyNameAR != "" && this.ApplicantData.FamilyNameAR != null){
         alert('You are not using arabic letters For Family name Arabic')
         return
       }
      else if(!this.isArabicChars(this.ApplicantData.LastNameAR)){
         alert('You are not using arabic letters For Last name Arabic')
         return
       }
      else if(!this.isEnglishChar(this.ApplicantData.SecondNameEN)){
         alert('You are using arabic letters For Second name English')
         return
       }
      else if(!this.isEnglishChar(this.ApplicantData.ThirdNameEN)){
         alert('You are using arabic letters For Third name English')
         return
       }
      else if(!this.isEnglishChar(this.ApplicantData.FamilyNameEN) && this.ApplicantData.FamilyNameEN != "" && this.ApplicantData.FamilyNameEN != null){
         alert('You are using arabic letters For Family name English')
         return
       }
      
       else{

     
        this.$validator.validate().then(isValid => {
          if (isValid) {
            this.loading= true;
                      this.$store.dispatch('auth/Review', this.reviewApplication+1 )

            ApplicantDataService.PostPersonalData(this.ApplicantData).then(
              res => {
                this.message = res.data;
                this.successful = true;
                this.loading = false;
                ApplicantService.GetRegesterdData(this.currentUser.UserIDSerial).then(Response =>{
                  
                  this.ApplicantData = Response.data
                 
                })
              },
              error => {
               this.message =
               (error.response && error.response.data && error.response.data.Message) ||
                 error.message ||  
                   error.toString();
               this.successful = false;
               this.loading = false;
              }
            );
          }
        });
          }
  }
  }
  }
</script> 

<style scoped>

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
    border: 1px solid #d4d4d4;
padding:0px 0px 50px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.mt-20{
  margin-top:20px;
}
.mt-40{
  margin-top:40px;
}

th{
font-weight:bold;
}
.text-center{
    text-align:center !important;
}
h6{
    color:#949494;
}

.su-border {
    border-color: #3D8FE3 !important;
    background: #F1F9FF !important;
}

input:disabled{
  background-color: bisque !important;
}
form{
  margin: 10px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

</style>